import React from 'react';
import { ArcSkeleton, ArcStack, ArcText } from '@src/core/ui';
import RuntimeItemRow from './runtime-item-row';
import { cardBaseSx } from '../../card-styles';
import type { RuntimeSectionProps } from '../types';

const CARD_SX = {
  ...cardBaseSx,
  borderRadius: '8px',
  padding: 3,
} as const;

const SKELETON_ROW_COUNT = 6;

const RuntimeSection: React.FC<RuntimeSectionProps> = ({
  title,
  items,
  isLoading,
  onAdjustOptionClick,
  onReplaceClick,
}) => (
  <ArcStack gap={2} spacing={1} sx={CARD_SX}>
    <ArcText.caption fontSize={16}>{title}</ArcText.caption>
    {isLoading ? (
      <React.Fragment>
        {Array.from({ length: SKELETON_ROW_COUNT }).map((_, index) => (
          <ArcSkeleton key={index} height={42} />
        ))}
      </React.Fragment>
    ) : (
      items.map((item) => (
        <RuntimeItemRow
          key={item.name}
          {...item}
          onAdjustOptionClick={onAdjustOptionClick}
          onReplaceClick={onReplaceClick}
        />
      ))
    )}
  </ArcStack>
);

export default RuntimeSection;
